/**
 * URL Configuration Service
 *
 * This module handles URL configuration for the frontend application,
 * including base URLs for the API and public-facing short URLs.
 */

// API Base URL - used for API requests
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://sqr.bright.blue';

// Public Base URL - used for displaying shortened URLs
export const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_API_URL || 'http://sqr.bright.blue';

export default {
  API_BASE_URL,
  PUBLIC_BASE_URL
};
